const mutations = {
  setUserInfo(state,userInfo){
    state.userInfo = userInfo
  }
}
export default mutations
